import { Platform } from "react-native";
import Config from "react-native-config";

const getEnvVariable = (key: string): string | undefined => {
  if (Platform.OS === "web") {
    return process.env[key];
  } else {
    return Config[key];
  }
};

export { getEnvVariable };
